import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/tdee-calculator',
  component: () => import('../../routes/TdeeCalculator.svelte'),
  card: {
    id: 'tdee-calculator',
    title: 'TDEE Calculator',
    description:
      'Calculate your Total Daily Energy Expenditure (TDEE) from BMR and activity level. Includes calorie targets for cut/maintain/bulk, macro split, and weekly weight-change projection.',
    icon: 'local_fire_department',
    iconBgClass: 'bg-orange-50',
    iconTextClass: 'text-orange-600',
    href: '/tdee-calculator',
    category: 'Health & Fitness',
  },
  seo: {
    title: 'TDEE Calculator – Total Daily Energy Expenditure',
    description:
      'Free TDEE calculator. Compute Total Daily Energy Expenditure from BMR (Mifflin-St Jeor or Katch-McArdle) and your activity multiplier. Get calorie targets for cut, maintain, or bulk, plus macro split and weekly weight-change estimate.',
  },
};

export default meta;